import { DialogTitle, styled } from '@mui/material';

export const StyledTitle = styled(DialogTitle, {
  shouldForwardProp: prop => prop !== 'isMobile'
})<{ isMobile: boolean }>(({ isMobile, theme }) => ({
  paddingBottom: theme.spacing(1),
  ...(isMobile && {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(1)
  })
}));
